module.exports = __webpack_public_path__ + "static/media/icons_Bilan premiers pas.25513cc9.svg";